/**
 * @function isJestTest
 * @description Determines if the current process is being run by Jest.
 *
 * @returns {boolean}
 */

export default function isJestTest() {
	return ! ( process?.env?.JEST_WORKER_ID === undefined || process?.env?.NODE_ENV !== 'test' );
}
